import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";
import ClientPaymentReport from "../../components/reports/ClientPaymentReport";
import setTitle from "../../helpers/TitleComponent";

export default class ClientPaymenReportPage extends Component {
  componentDidMount() {
    setTitle("Client Payment Report");
  }
  render() {
    return (
      <div>
        <MyNavbar />
        <ClientPaymentReport />
      </div>
    );
  }
}
